import './sticky-cta.scss';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin( ScrollTrigger );

function measureTextWidth( text, btn ) {
	const style = window.getComputedStyle( btn );
	const span  = document.createElement( 'span' );

	span.textContent         = text;
	span.style.fontFamily    = style.fontFamily;
	span.style.fontSize      = style.fontSize;
	span.style.fontWeight    = style.fontWeight;
	span.style.letterSpacing = style.letterSpacing;
	span.style.position      = 'absolute';
	span.style.visibility    = 'hidden';
	span.style.whiteSpace    = 'nowrap';

	document.body.appendChild( span );
	const width = span.offsetWidth + 5;
	document.body.removeChild( span );

	return width;
}

function animateText( btn, textWrapper, newText ) {
	const textWidth = measureTextWidth( newText, btn );
	const btnWidth  = textWidth + 40;

	gsap.killTweensOf( btn );
	gsap.killTweensOf( textWrapper );

	// Remove leftover spans from previous in-flight transitions
	Array.from( textWrapper.querySelectorAll( '.p-stickyCta__text' ) )
		.slice( 0, -1 )
		.forEach( ( s ) => s.remove() );

	const oldSpan       = textWrapper.querySelector( '.p-stickyCta__text' );
	const newSpan       = document.createElement( 'span' );
	newSpan.className   = 'p-stickyCta__text';
	newSpan.textContent = newText;
	textWrapper.appendChild( newSpan );

	gsap.set( oldSpan, { y: 0 } );
	gsap.set( newSpan, { y: '24px' } );

	gsap.timeline()
		.to( btn,         { width: btnWidth,  duration: 0.5, ease: 'power3.inOut' }, 0 )
		.to( textWrapper, { width: textWidth, duration: 0.5, ease: 'power3.inOut' }, 0 )
		.to( oldSpan,     { y: '-24px',       duration: 0.5, ease: 'power3.inOut' }, 0 )
		.to( newSpan,     { y: '0px',         duration: 0.5, ease: 'power3.inOut', onComplete: () => oldSpan.remove() }, 0 );
}

function initStickyCta() {
	const root        = document.querySelector( '[data-component="sticky-cta"]' );
	const btn         = root?.querySelector( '.p-stickyCta__btn' );
	const textWrapper = btn?.querySelector( '.p-stickyCta__textWrapper' );

	if ( ! root || ! btn || ! textWrapper ) {
		return;
	}

	const defaultText = root.dataset.defaultText || 'Vraag gratis waardebepaling aan';
	const defaultUrl  = root.dataset.defaultUrl  || '';

	let currentText = defaultText;
	let currentUrl  = defaultUrl;

	btn.addEventListener( 'click', () => {
		if ( currentUrl ) {
			window.location.href = currentUrl;
		}
	} );

	// Set initial explicit sizes so width-based GSAP tweens have a starting point
	const initTextWidth = measureTextWidth( currentText, btn );
	gsap.set( btn,         { width: initTextWidth + 40 } );
	gsap.set( textWrapper, { width: initTextWidth } );

	// Entrance animation — grow from a sliver
	const initSpan = textWrapper.querySelector( '.p-stickyCta__text' );
	gsap.timeline( { delay: 0.6 } )
		.fromTo( btn,
			{ width: 10, padding: 0 },
			{ width: initTextWidth + 40, padding: '0 20px', duration: 1.0, ease: 'power4.inOut', clearProps: 'padding' },
			0
		)
		.from( initSpan, { y: '24px', opacity: 0, duration: 0.8, ease: 'power3.out' }, 0.3 );

	// Wire up text/url changes for blocks/sections with [data-cta-text]
	document.querySelectorAll( '[data-cta-text]' ).forEach( ( section ) => {
		const onEnter = () => {
			const text = section.dataset.ctaText;
			const url  = section.dataset.ctaUrl || defaultUrl;

			if ( text && text !== currentText ) {
				currentText = text;
				currentUrl  = url;
				animateText( btn, textWrapper, text );
			} else if ( text === currentText && url !== currentUrl ) {
				// Same text, different URL — update silently
				currentUrl = url;
			}
		};

		ScrollTrigger.create( {
			trigger:     section,
			start:       'top 85%',
			end:         'bottom 85%',
			onEnter:     onEnter,
			onEnterBack: onEnter,
		} );
	} );

	ScrollTrigger.refresh();
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initStickyCta );
} else {
	initStickyCta();
}
